import { React, useState } from "react";

import { NavLink, useLocation, Link } from "react-router-dom";

import Logo from "./Logo";
import { FaHome, FaRegImages } from "react-icons/fa";
import { MdEmojiEvents, MdGroups } from "react-icons/md";
import { RiGalleryFill } from "react-icons/ri";
import { FiLogIn } from "react-icons/fi";

import { motion } from "framer-motion";

export default function Navbar() {
    const [isActive, setisActive] = useState(false);
    const currentPath = useLocation().pathname;

    const handleMenuToggle = () => {
        setisActive(!isActive);
    };

    return (
        <motion.div animate={{ y: [-100, 0] }}>
            <nav className="navbar is-transparent is-fixed">
                <div className="navbar-brand">
                    <NavLink to="/" onClick={() => setisActive(!isActive)}>
                        <Logo />
                    </NavLink>

                    <NavLink
                        to="/"
                        onClick={() => setisActive(!isActive)}
                        className="is-link"
                    >
                        <h1 className="is-size-3 m-4 p-3 title">CSEA</h1>
                    </NavLink>

                    {/* Add navbar-start div in future */}
                    <div
                        onClick={handleMenuToggle}
                        style={{ marginTop: "19px", marginRight: "19px" }}
                        className={`navbar-burger ${
                            isActive ? "is-active" : ""
                        }`}
                        role="button"
                        aria-label="menu"
                        aria-expanded="false"
                        data-target="navbar"
                    >
                        <span aria-hidden="true"></span>
                        <span aria-hidden="true"></span>
                        <span aria-hidden="true"></span>
                    </div>
                </div>

                <div
                    id="navbar"
                    className={`navbar-menu ${isActive ? "is-active" : ""}`}
                >
                    <div className="navbar-end">
                        <NavLink
                            to="/"
                            onClick={() => setisActive(!isActive)}
                            activeclassname="is-active"
                            className={`navbar-item is-tab nav-link${
                                currentPath === "/" ? " is-active" : ""
                            }`}
                        >
                            <FaHome className="mr-2" />
                            Home
                        </NavLink>
                        <NavLink
                            to="/events"
                            onClick={() => setisActive(!isActive)}
                            activeclassname="is-active"
                            className={`navbar-item is-tab nav-link${
                                currentPath === "/events" ? " is-active" : ""
                            }`}
                        >
                            <MdEmojiEvents className="mr-2" />
                            Events
                        </NavLink>
                        <NavLink
                            to="/gallery"
                            onClick={() => setisActive(!isActive)}
                            activeclassname="is-active"
                            className={`navbar-item is-tab nav-link${
                                currentPath === "/gallery" ? " is-active" : ""
                            }`}
                        >
                            <FaRegImages className="mr-2" />
                            Gallery
                        </NavLink>
                        <NavLink
                            to="/resources"
                            onClick={() => setisActive(!isActive)}
                            activeclassname="is-active"
                            className={`navbar-item is-tab nav-link${
                                currentPath === "/resources" ? " is-active" : ""
                            }`}
                        >
                            <RiGalleryFill className="mr-2" />
                            Resources
                        </NavLink>
                        <NavLink
                            to="/team"
                            onClick={() => setisActive(!isActive)}
                            activeclassname="is-active"
                            className={`navbar-item is-tab nav-link${
                                currentPath === "/team" ? " is-active" : ""
                            }`}
                        >
                            <MdGroups className="mr-2" />
                            Team
                        </NavLink>
                        <Link
                            to="/login"
                            onClick={() => setisActive(!isActive)}
                            activeclassname="is-active"
                            className={`navbar-item is-tab nav-link${
                                currentPath === "/login" ? " is-active" : ""
                            }`}
                        >
                            <FiLogIn className="mr-2" />
                            InterNit
                        </Link>
                    </div>
                </div>
            </nav>
        </motion.div>
    );
}
